export default {
  head: {
    title: 'Customer Authentication operations billing',
    action: {
      create: {
        tooltip: 'Create new Customer Authentication report'
      },
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Customer Authentication billing operation'
    },
    details: {
      title: 'Operation details'
    }
  }
};
